import { TagGroupType } from '@editor/types';

// Returns specific tags of a group, based on provided group name (theme, style, color)
export const getTagsByGroup = (
  groupName: string,
  tagGroups: TagGroupType[]
) => {
  const tags =
    tagGroups
      ?.find((tagGroup) => tagGroup.name.toLowerCase() === groupName)
      ?.tags?.map((tag) => ({
        // TODO: change id to tag.id when refineByStyle is developed in the backend
        id: tag.name,
        label: tag.name,
        meta: tag.meta,
      })) || [];

  return tags;
};
